// 状态管理
import Vue from 'vue';

import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        activeTop: [],   // 顶部菜单栏状态
        activeSide: [],  // 侧边栏状态
        activeRoute: {},
    },
    mutations: {
        setActivePath(state, data){
            // 设置顶部菜单状态
            if (data.type == 'top') {
                state.activeTop = data.val;
            }
            // 设置侧边栏菜单状态
            if (data.type == 'side') {
                state.activeSide = data.val;
            }
            
            // 设置顶部&侧边栏状态
            
            if (data.type == 'all') {
                state.activeSide = data.val.side;
                state.activeTop = data.val.top;
            }
        },
        saveActiveRoute(state, data) {
            state.activeRoute = data;
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js